import React from "react";
import NavBar, { NavBarProps } from "./NavBar";
import PlayAlongContainer from "./PlayAlongContainer";
import "./NavAndContent.css";
import ClassOne from "./ClassOne";
import ClassThree from "./ClassThree";
import ClassTwo from "./ClassTwo";

function NavAndContent() {
    const [currentId, setId] = React.useState("play-along");
    const navBarOptions: NavBarProps = {
        options: [
            {
                displayName: "Play along",
                id: "play-along",
                component: <PlayAlongContainer />,
            } /*
            {
                displayName: "8:45 - 9:30",
                id: "class-one",
                component: <ClassOne />,
            },
            {
                displayName: "9:30 - 10:30 (Sumitpal)",
                id: "class-two",
                component: <ClassTwo />,
            },
            {
                displayName: "9:30 - 10:30 (Karan)",
                id: "class-three",
                component: <ClassThree />,
            },*/,
        ],
        onItemSelected: (id) => setId(id),
    };
    return (
        <div id="nav-bar-container">
            <NavBar {...navBarOptions} />
            <div id="nav-bar-content">
                {
                    navBarOptions.options.find((opt) => opt.id === currentId)
                        ?.component
                }
            </div>
        </div>
    );
}

export default NavAndContent;
